import { LinkfluenceAPI } from "@linkfluence/api";
import { getApiHost } from "@linkfluence/konf";
import { App } from "@linkfluence/models/app";
import { ImageClustersData } from "@radarly/models/insights";
import { SearchParams } from "@radarly/models/search";

export class InsightsAPI extends LinkfluenceAPI {
  public constructor() {
    super({
      endpoint: "",
    });
  }
  public async getImageClustering(projectId: number, query: SearchParams) {
    return this.post<ImageClustersData>(
      getApiHost(App.Radarly) +
        `/3.0/projects/${projectId}/insights/cluster-images.json`,
      query.query
    );
  }
}
